import { ContentfulEntryType } from './contentful-entry.type';

export class PaymentInfoBlockType extends ContentfulEntryType {
  public get contentEntryTitle(): string {
    return this.fields['contentEntryTitle'];
  }

  public get paymentBlockInfo(): string {
    return this.fields['paymentBlockInfo'];
  }

  public get paymentBlockTooltip(): string {
    return this.fields['paymentBlockTooltip'];
  }

}


